<div>
  <div
    class="dashboard-top sticky top-0 z-[300] bg-white flex flex-col md:contents"
  >
    <!-- filters (mobile: 2nd, desktop: 1st) — hidden on mobile for User Activity -->
    <div
      class="order-2 md:order-none md:sticky md:-top-5 z-[200]"
      [class.ua-hide-mobile]="state === 'user_activity'"
    >
      <app-top-filters></app-top-filters>
    </div>

    <!-- summary cards (mobile: 3rd, desktop: 2nd) — hidden on mobile for User Activity -->
    <app-summary-cards
      class="order-3 md:order-none md:sticky md:top-10 z-[200]"
      [class.ua-hide-mobile]="state === 'user_activity'"
    ></app-summary-cards>

    <!-- operational indicators / user activity toggle (mobile: 1st, desktop: 3rd) -->
    <div
      class="dashboard-toggle inline-block w-full md:w-auto my-3 order-1 md:order-none"
    >
      <app-button-toggle-ui
        [buttons]="states"
        (stateEmit)="onStateChange($event)"
      ></app-button-toggle-ui>
    </div>
  </div>

  <!-- action needed (sits between the indicator toggle and the charts) -->
  <app-action-board></app-action-board>

  <!-- switched content -->
  <div class="mobile-content-gap">
    <ng-container [ngSwitch]="state">
      <div *ngSwitchCase="'operational_indicators'">
        <app-operational-indicators></app-operational-indicators>
      </div>

      <div *ngSwitchCase="'financial_indicator'">
        <app-financial-indicators></app-financial-indicators>
      </div>

      <div *ngSwitchCase="'user_activity'">
        <app-user-activity></app-user-activity>
      </div>
    </ng-container>
  </div>
</div>
